/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-12-04 22:22:20
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import { modalFactory } from 'src/util/vueExtend';
import { Toast } from 'src/util/toast';
import UserConfigApi from './api/userConfigApi';

export namespace AddStationVOI {
    export interface PropsI {
        userId?: number;
        organizationId?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }
}

@Component
class AddStationModal extends Vue.Component<AddStationVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    userId!: number;

    @Prop({
        type: Number,
    })
    organizationId!: number;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    data: any = [];
    target: number[] = [];

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        let { code } = await UserConfigApi.saveOrganizationStation(this.userId, this.target);
        if (code === 0) {
            Toast.success('新增组织成功！');
            this.saveSuccess();
            this.closeModal();
        }
    }
    async mounted() {
        this.queryOrganizationStation();
    }
    async queryOrganizationStation() {
        let { code, data } = await UserConfigApi.queryAllStation({user_id: this.userId, organization_id: this.organizationId});
        if (code === 0) {
            this.data = data.map(i => ({ key: i.device_id, label: i.device_name }));
            this.target = data.filter(i => i.select === 1).map(i => i.device_id);
        }
    }
    render(h) {
        return (
            <Modal title="添加站点" width="820" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <transfer
                    list-style={{ width: '350px', height: '500px' }}
                    data={this.data}
                    target-keys={this.target}
                    filterable
                    on-on-change={v => (this.target = v)}
                />
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertAddStationModal(userId?: number, organizationId?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<AddStationVOI.PropsI>(AddStationModal)({
            userId,
            organizationId,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
